<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2 text--base">
        <SurveyMeasures :title="measuresTitle" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import SurveyMeasures from '@/components/content/chapter2/SurveyMeasures.vue';

export default {
  name: 'App5BarChart',
  components: {
    SurveyMeasures,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    measuresTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'survey-measures').title : '';
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  }
};
</script>

<style scoped>
.container {
  background-color: #f8f7f5;
}
</style>
